<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div class="rate-wrap">
        <div class="rate">
          <star-rating
            v-model.number="fieldValue"
            :star-size="22"
            :border-width="2"
            :rounded-corners="true"
            :star-points="[
              23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46,
              19, 31, 17,
            ]"
            :round-start-rating="false"
            text-class="hidden"
            active-color="#fdcf6e"
            border-color="transparent"
          />
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import FormRatingField from "../../../common/FormRatingField.vue";

export default {
  extends: FormRatingField,
};
</script>
